import React, { useState, useEffect, useRef, useContext } from "react";
import { ResponsiveContainer, Cell, PieChart, Pie } from "recharts";
import Title from "./Title";
import useTickets from "../../hooks/useTickets";
import { AuthContext } from "../../context/Auth/AuthContext";
import Column from "../../layout/components/Column";
import { CircularProgress, Grid, TextField, useTheme } from "@material-ui/core";
import CalendarToday from "@material-ui/icons/CalendarTodayRounded";
import Row from "../../layout/components/Row";
import Modal from "../../layout/components/Modal";

const ChartRatedTickets = () => {
  const { user } = useContext(AuthContext);
  const theme = useTheme();

  const getStartOfMonth = () => {
    const now = new Date();
    const iso = new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
    return iso;
  };
  const getEndOfMonth = () => {
    const now = new Date();
    const iso = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    ).toISOString();
    return iso;
  };

  const [modalFilterOpen, setModalFilterOpen] = useState(false);
  const [initialDate, setInitialDate] = useState(getStartOfMonth());
  const [finalDate, setFinalDate] = useState(getEndOfMonth());

  const initialDateInput = useRef();
  const finalDateInput = useRef();

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map(q => q.id);
  }

  const { tickets, loading } = useTickets({
    status: "closed",
    showAll: "true",
    withUnreadMessages: "false",
    queueIds: JSON.stringify(userQueueIds),
    date: initialDate,
    fDate: finalDate,
    unlimited: "true"
  });

  const [chartData, setChartData] = useState([
    { name: "Não Avaliado", value: 0 },
    { name: "Avaliado", value: 0 }
  ]);

  useEffect(() => {
    setChartData(prevState => {
      let aux = [...prevState];

      aux[0].value = tickets.filter(t => !t.rate).length;
      aux[1].value = tickets.filter(t => t.rate).length;

      return aux;
    });
  }, [tickets]);

  const COLORS = ["#161616", "#008C6E"];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const handleFilterClick = e => {
    e.preventDefault();
    setModalFilterOpen(prev => !prev);
  };

  const handleInitialDateChange = value => {
    setInitialDate(new Date(value + "T04:00:00.000Z").toISOString());
  };

  const handleFinalDateChange = value => {
    setFinalDate(new Date(value + "T04:00:00.000Z").toISOString());
  };

  return (
    <React.Fragment>
      <Row>
        <Column>
          <Title noMargin>{`Avaliações x Tickets Finalizados`}</Title>
          <span
            style={{ fontSize: ".7rem", color: theme.palette.text.secondary }}
          >
            {new Date(initialDate).toLocaleDateString()} -{" "}
            {new Date(finalDate).toLocaleDateString()}
          </span>
        </Column>
        <Column wAuto>
          <CalendarToday
            fontSize="small"
            style={{ cursor: "pointer" }}
            onClick={handleFilterClick}
          />
          <Modal
            modalOpen={modalFilterOpen}
            onClose={() => {
              setModalFilterOpen(false);
            }}
            onOK={() => {
              handleInitialDateChange(initialDateInput.current.value);
              handleFinalDateChange(finalDateInput.current.value);
              setModalFilterOpen(false);

              //TODO: UpdateTicket
            }}
            title={"Filtros"}
          >
            <Grid container spacing={1}>
              <Grid item>
                <TextField
                  inputRef={initialDateInput}
                  label={"Data Inicial"}
                  variant="outlined"
                  type="date"
                  defaultValue={initialDate.slice(0, 10)}
                  //onChange={handleInitialDateChange}
                />
              </Grid>
              <Grid item>
                <TextField
                  inputRef={finalDateInput}
                  label={"Data Final"}
                  variant="outlined"
                  type="date"
                  defaultValue={finalDate.slice(0, 10)}
                  //onChange={handleFinalDateChange}
                />
              </Grid>
            </Grid>
          </Modal>
        </Column>
      </Row>
      {loading ? (
        <Row h100 aiCenter jcCenter>
          <center>
            <CircularProgress />
          </center>
        </Row>
      ) : tickets.length === 0 ? (
        <Row h100 aiCenter jcCenter>
          <center>
            <span style={{ color: "red" }}>
              Sem dados para exibir o gráfico
            </span>
          </center>
        </Row>
      ) : (
        <Row h100 aiCenter>
          <Column>
            <Row aiCenter>
              <div
                style={{
                  content: "*",
                  width: "30%",
                  backgroundColor: COLORS[0],
                  height: 10,
                  borderRadius: 20
                }}
              ></div>
              <span style={{ width: "100%", marginLeft: 7 }}>
                Não avaliado ({chartData[0].value})
              </span>
            </Row>
            <Row aiCenter>
              <div
                style={{
                  content: "*",
                  width: "30%",
                  backgroundColor: COLORS[1],
                  height: 10,
                  borderRadius: 20
                }}
              ></div>
              <span style={{ width: "100%", marginLeft: 7 }}>
                Avaliado ({chartData[1].value})
              </span>
            </Row>
          </Column>
          <ResponsiveContainer>
            <PieChart
              width={730}
              height={250}
              margin={{
                top: 0,
                right: 16,
                bottom: 0,
                left: 24
              }}
            >
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Row>
      )}
    </React.Fragment>
  );
};

export default ChartRatedTickets;
